import React from "react";
import { useEffect } from "react";
import $ from "jquery";
const TimePickerObserver = (timePickerInputBox) => {
    const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [screenWidth]);
    if (screenWidth > 768) {
        let timepickerObserver = new MutationObserver(mutations => {
            for (let mutation of mutations) {
                if (mutation.type === "childList" && mutation.target.classList.contains('ui-timepicker-viewport')) {
                    for (const node of Array.from(mutation.addedNodes)) {
                        if (node instanceof HTMLElement && node.classList.contains('ui-menu-item')) {
                            let innerNode = node.querySelector('.ui-corner-all');
                            if (innerNode instanceof HTMLElement && !innerNode.classList.contains('js-updated')) {
                                innerNode.classList.add('js-updated');
                                innerNode.setAttribute('data-time', innerNode.innerText);
                                let nodeText = innerNode.innerText.split(' ');
                                innerNode.innerHTML = `<span>${nodeText[0]}</span><span>${nodeText[1]}</span>`;
                            }
                        }
                    }
                }
                const $timepicker = $('.ui-timepicker-container');
                const $input = $('#timepicker');
                if ($timepicker.length && $input.length) {
                    const viewport = window.innerHeight;
                    const timepickerHeight = 320;
                    const inputPos = $input.offset();
                    const inputHeight = $input.outerHeight() || 0;
                    if (inputPos) {
                        const inputBottom = inputPos.top + inputHeight;
                        if (viewport - inputBottom < timepickerHeight) {
                            $timepicker.css('top', (inputPos.top - timepickerHeight - 10) + 'px');
                            $timepicker.addClass('ui-timepicker-above');
                        }
                        else {
                            $timepicker.removeClass('ui-timepicker-above');
                        }
                    }
                }
            }
        });
        const timepickerEle = document.querySelector('.ui-timepicker-container');
        if (timepickerEle) {
            timepickerObserver.observe(timepickerEle, {
                childList: true,
                attributes: true,
                subtree: true
            });
        }
    }
};
export default TimePickerObserver;
